import { ReactElement } from 'react'
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps
} from 'react-router-dom'
import { useSelector } from 'react-redux'
import ErrorBoundary from 'ui/ErrorBoundaries/ErrorBoundary'
import { RootState } from 'redux/rootReducer'
import routePaths from 'const/routePaths'

const ProtectedRoute = ({
  component: Component,
  ...props
}: RouteProps): ReactElement => {
  const { tokenInfo: { access_token: accessToken = null } = {} } = useSelector(
    (state: RootState) => state.authTokenInfo
  )

  return (
    <Route
      {...props}
      render={(routeProps: RouteComponentProps): ReactElement =>
        accessToken ? (
          <ErrorBoundary>
            <Component {...routeProps} />
          </ErrorBoundary>
        ) : (
          <Redirect to={routePaths.home} />
        )
      }
    />
  )
}

export default ProtectedRoute
